<template>
  <v-data-table
    :headers="headers"
    :items="relations"
    :items-per-page="10"
    :sort-by="['id']"
    sort-desc
  >
    <template v-slot:item.key="{ item }">
      <v-checkbox v-model="item.key" disabled></v-checkbox>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item.person_id)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { Notification } from '@/modules/notifications/Notification';

export default {
  name: 'Helper',

  props: {
    relations: {
      type: Array,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('RELATIONS.RELATIONSHIP'),
          value: 'relationship'
        },
        {
          text: this.$t('RELATIONS.TO_PERSON'),
          value: 'full_name'
        },
        {
          text: this.$t('RELATIONS.KEY'),
          value: 'key'
        },
        {
          text: this.$t('RELATIONS.PRIORITY'),
          value: 'priority'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  methods: {
    formatDate(data) {
      return Notification.formatDate(data);
    }
  }
};
</script>
